import Axois from '../utils/axios'
import EventEmitter from "../../utils/eventEmitter";
import { useOutletContext } from 'react-router-dom';



export const loadTransfers = async () => {
  let response = await Axois.get('/transfers').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}

export const loadPickLaterTransfers = async () => {
  let response = await Axois.get('/transfers/find/pick-laters').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
  const responseData = await response.data;
  return responseData;
}

export const loadTransferByOption = async (option) => {
  const filter = JSON.parse(option);
  let pagination_ = {};
  let filters = {search: {by: 'op', values: [filter.seo], filters: [filter.status]}};
  let response = await Axois.get(`transfers/search?filter=${JSON.stringify(filters)}&&pagination=${JSON.stringify(pagination_)}`).catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
  const responseData = await response.data;
  // let response = await Axois.get('/transfers/find/by/'+option).catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
  // const responseData = await response.data;
  return responseData;
}



export const loadOverview = async () => {
  let response = await Axois.get('/transfers/overview').catch(err =>{ console.log(err); throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
  const responseData = await response.data;
  return responseData;
}


export const loadTransfer = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/transfers');
        const responseData = await requests.data;
        return { ...responseData, transfer: {}};
        // return { products:[], locations:[], operationTypes:[], transfer: {}}
      
      default:
        let response = await Axois.get('/transfers/find/'+action);
        const responseJson = await response.data;
        return responseJson;
    }
  }catch (err) {
    console.log(err);
  }
}

export const loadRequestTransfer = async (number) => {
  let response = await Axois.get('/transfers/stock-request/transfer/'+number).catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


const useTransferAPI = () => {
  const { success, error } = useOutletContext();
  
  const create = async (data) => {
    try {
      const response = await Axois.post('/transfers', data);
      const responseData = await response.data;
      if (responseData.status === 'error') return error(responseData.message);
      success(responseData.message);
      EventEmitter.dispatch('transfer_response', data.number);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (number, data) => {
    try {
      const response = await Axois.put('/transfers/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('transfer_response', responseData.number);
    }catch (err) {
      console.log(err);
    }
  }

  const availability = async (number, data) => {
    try {
      const response = await Axois.patch('/transfers/check-product-availability/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('transfer_response', responseData.number);
    }catch (err) {
      if (err.code === 'ERR_NETWORK') {
        error("Couldn't process request. Please check your network connectivity");
      }else {
        error(err.response?.data?.message);
      }
      console.log(err);
    }
  }

  const validateRequestTransfer = async (number, data) => {
    try {
      const response = await Axois.put('/transfers/stock-request/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('transfer_response', responseData.number);
    }catch (err) {
      console.log(err);
    }
  }

  return { create, update, availability, validateRequestTransfer };
}


export default useTransferAPI;